import { render, staticRenderFns } from "./SideBarItem.vue?vue&type=template&id=d196d8a0&scoped=true&"
import script from "./SideBarItem.vue?vue&type=script&lang=js&"
export * from "./SideBarItem.vue?vue&type=script&lang=js&"
import style0 from "./SideBarItem.vue?vue&type=style&index=0&id=d196d8a0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d196d8a0",
  null
  
)

export default component.exports